import { type SelectInputProps, SelectInput, useGetList } from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";

type ClientAppInputProps = Omit<
  SelectInputProps,
  "choices" | "optionText" | "isPending" | "filter"
> & {
  filter?: Record<string, unknown>;
};

export const ClientAppInput = ({
  filter = {},
  ...props
}: ClientAppInputProps) => {
  const { isPending, data } = useGetList(MODULE_NAMES.CLIENT_APPS, {
    filter: {
      pagination: false,
      ...filter,
    },
  });

  return (
    <SelectInput
      {...props}
      source={props.source}
      isPending={isPending}
      optionValue={props.optionValue ?? "@id"}
      optionText="title"
      choices={data ?? []}
    />
  );
};
